<template>
  <UserDetails v-if="userId || createNewUser" :userId="userId" :createNew="createNewUser" />
</template>

<script>
import UserDetails from '@/components/UserDetails.vue'

export default {
  name: 'EditUser',
  components: {
    UserDetails
  },
  data: () => {
    return {
      userId: undefined,
      createNewUser: false
    }
  },
  mounted() {
    const routeId = this.$route.params.id

    switch(routeId) {
      case "me":
        this.userId = this.$store.state.user.id
        break
      case "create":
        this.createNewUser = true
        break
      default:
        this.userId = routeId
        break
    }
  }
}
</script>
